export default {"src":"/_next/static/media/support-icon.2915bec6.svg","height":15,"width":20};